<template>
    <div class="mb-3">
      <select class="form-select" v-model="selectedId" @change="onChange">
        <option value="all">{{ allOptionText }}</option>
        <option v-for="apt in aptGroups" :key="apt.id" :value="apt.id">
          {{ apt.name }}
        </option>
      </select>
    </div>
  </template>
  
  <script>
  export default {
    name: 'SelectApt',
    props: {
      aptGroups: {
        type: Array,
        default: () => []
      },
      selectedAPT: {
        type: Object,
        default: () => ({ id: 'all', name: 'All APTs', type: 'all' })
      }
    },
    data() {
      return {
        selectedId: 'all'
      }
    },
    watch: {
      selectedAPT: {
        handler(newSelectedAPT) {
          if (newSelectedAPT && newSelectedAPT.id) {
            this.selectedId = newSelectedAPT.id;
          }
        },
        immediate: true
      }
    },
    computed: {
      allOptionText() {
        return this.$i18n ? this.$i18n.t('all') : 'All APTs'
      }
    },
    mounted() {
      // Select "All" by default
      this.selectedId = 'all';
      this.$emit('select-apt', { id: 'all', name: 'All APTs', type: 'all' });
    },
    methods: {
      onChange() {
        if (this.selectedId === 'all') {
          // Emit special "all" object
          this.$emit('select-apt', { id: 'all', name: 'All APTs', type: 'all' });
        } else {
          // Find the APT group corresponding to the selected ID.
          const apt = this.aptGroups.find(a => a.id === this.selectedId);
          if (apt) {
            this.$emit('select-apt', apt);
          }
        }
      }
    }
  }
  </script>
  